import React, { useEffect } from "react";
import GlobalStyles from "./Styles/global";
import { CartorioProvider, useCartorio } from "./Hooks/cartorio";
import { Routes } from "./Routes";
import { SocketProvider } from "./Hooks/socketHelper";
import { ImovelProvider } from "./Hooks/imoveis";
import {
  FuncionarioCartorioProvider,
  useFuncionarioCartorio,
} from "./Hooks/funcionarioCartorio";
import { PrefeituraProvider, usePrefeitura } from "./Hooks/usePrefeitura";
import {
  FuncionarioPrefeituraProvider,
  useFuncionarioPrefeitura,
} from "./Hooks/funcionarioPrefeitura";
import { AvaliacaoProvider } from "./Hooks/avaliado";
import { GuiaProvider } from "./Hooks/guia";
import { SupportLogo } from "./Components/Suporte";

function App() {
  const {
    funcionarioCartorioIsLogged,
    helpSignInHashFuncionarioCartorio,
  } = useFuncionarioCartorio();
  const { cartorioIsLogged, validateToken } = useCartorio();
  const { prefeituraIsLogged, helpSignInHashPrefeitura } = usePrefeitura();
  const {
    funcionarioPrefeituraIsLogged,
    helpSignInHashFuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  function helpToken() {
    // for (let index = 0; index == 1000; index++) {
    //   console.log(index);
    // new Promise((r) =>
    //   setTimeout(() => {
    if (funcionarioPrefeituraIsLogged) {
      helpSignInHashFuncionarioPrefeitura();
    }
    if (funcionarioCartorioIsLogged) {
      window.alert("AQUI");
      helpSignInHashFuncionarioCartorio();
    }
    if (cartorioIsLogged) {
      validateToken();
    }
    if (prefeituraIsLogged) {
      helpSignInHashPrefeitura();
    }
    // }, (index + 1) * 720000)
    // );
    // }
  }

  useEffect(() => {
    if (
      window.location.href.indexOf("https") == -1 &&
      window.location.href.indexOf("localhost:3000") == -1
    ) {
      window.location.href = window.location.href.replace("http", "https");
    }
  }, []);

  useEffect(() => {
    helpToken();
  }, []);
  return (
    <div>
      <GlobalStyles />

      <CartorioProvider>
        <FuncionarioCartorioProvider>
          <PrefeituraProvider>
            <FuncionarioPrefeituraProvider>
              <AvaliacaoProvider>
                <SocketProvider>
                  <GuiaProvider>
                    <Routes />
                  </GuiaProvider>
                </SocketProvider>
              </AvaliacaoProvider>
            </FuncionarioPrefeituraProvider>
          </PrefeituraProvider>
        </FuncionarioCartorioProvider>
      </CartorioProvider>

    </div>
  );
}

export default App;
